// extracted by mini-css-extract-plugin
export var bsd = "text-module--bsd--B0TLi";
export var byline = "text-module--byline--ENhW8";
export var chapterSummary = "text-module--chapterSummary--9mGrw";
export var copyrightGraf = "text-module--copyrightGraf--UvbXP";
export var paragraph = "text-module--paragraph--3YyVI";
export var quoteGraf = "text-module--quoteGraf--9MvZf";